import { useUploadImage } from 'pages/MyInfo/Cars/hooks/useUploadImage';
import { FC, useMemo } from 'react';
import { FormModeProps } from 'shared/interfaces/IModalForm';
import { ITalentAssetsProps } from 'shared/interfaces/ITalent';
import { useAssetsPropsForm } from '../hooks/useAssetsPropsForm';
import { PropsIcon } from '@room-match/shared-ui-components';
import { HandleAddItemProps, HandleEditItemProps } from 'shared/hooks/PetsCars/useSubmitForm';
import ModalForm from 'components/MyInfo/ModalForm/ModalForm';
import AssetsPropsForm from './AssetsPropsForm/AssetsPropsForm';

type ItemProps = {
  type: string;
  item: string;
};

type AssetsPropsAddEditModalProps = {
  data?: ITalentAssetsProps | undefined;
  mode: FormModeProps;
  openModal: boolean;
  handleOpenModal: VoidFunction;
  handleAddAssetsProps: (value: HandleAddItemProps<ItemProps>) => void;
  handleEditAssetsProps: (value: HandleEditItemProps<ItemProps>) => void;
};

const AssetsPropsAddEditModal: FC<AssetsPropsAddEditModalProps> = ({
  data,
  mode,
  openModal,
  handleOpenModal,
  handleAddAssetsProps,
  handleEditAssetsProps,
}) => {
  const {
    handleRemoveImages,
    handleOnDropImage,
    uploadedFiles,
    filesToBeSaved,
    handleFilesToBeSaved,
    handleOnDragEnd,
  } = useUploadImage({ current_saved_images: mode === 'edit' && data ? data?.attached_media || [] : [] });
  const { selectedItem, selectedType, assetsPropsForm } = useAssetsPropsForm(data);

  const isAllSelected = useMemo(() => Boolean(selectedItem && selectedType), [selectedItem, selectedType]);

  const handleSave = async () => {
    handleOpenModal();
    if (!isAllSelected) return;
    const assetPropsData = {
      type: selectedType,
      item: selectedItem,
      image_count: filesToBeSaved?.length || 0,
    };

    if (mode === 'add') {
      handleAddAssetsProps({
        filesToBeSaved,
        items: assetPropsData,
      });
    } else if (mode === 'edit') {
      handleEditAssetsProps({
        id: data?.id || '',
        items: assetPropsData,
        filesToBeSaved,
      });
    }
  };

  return (
    <ModalForm
      handleOnDragEnd={handleOnDragEnd}
      headerIcon={<PropsIcon fontSize={'inherit'} />}
      filesToBeSaved={filesToBeSaved}
      handleFilesToBeSaved={(newFile) => handleFilesToBeSaved(newFile)}
      uploadedFiles={uploadedFiles}
      openModal={openModal}
      handleOpenModal={handleOpenModal}
      handleUploadImages={(file: File[]) => {
        handleOnDropImage(file);
      }}
      handleRemoveImages={handleRemoveImages}
      title={mode === 'add' ? 'Add Your Assets / Props' : 'Edit Your Assets / Props'}
      formComponent={
        <AssetsPropsForm assetsPropsForm={assetsPropsForm} onSave={handleSave} disableSaveButton={!isAllSelected} />
      }
    />
  );
};

export default AssetsPropsAddEditModal;
